// ============================================================
// VCS.GuestInvite -- Gast zum Videoanruf einladen (Seite des Einladenden)
// ============================================================
// Zwei Aufgaben:
//   1. Gast-Link erzeugen (POST /invite/create mit kind='call') und ueber das
//      bestehende Einladungs-Fenster verschicken.
//   2. Das Klopfen des Gastes beantworten ('guest-knock' vom Server):
//      Annehmen betritt den Raum als Host, Ablehnen schickt 'guest-knock-deny'.
//
// Der Knopf wird per JS unter den Kontakt-Einladungslink im "Neuer Chat"-Dialog
// gesetzt -- dafuer braucht es kein eigenes Markup in index.php.
// ============================================================
window.VCS = window.VCS || {};

VCS.GuestInvite = class {

    // So lange steht der Klingel-Dialog. Der Server beendet das Klopfen nach
    // 90 s ebenfalls (GUEST_KNOCK_TIMEOUT_MS in main-server.js).
    static KNOCK_TIMEOUT_MS = 90000;

    constructor() {
        this._knockRoomId = null;
        this._knockTimer  = 0;
        this._creating    = false;
    }

    init() {
        this._injectButton();
    }

    // -- Gast-Link erzeugen ---------------------------------------

    async createLink() {
        if (this._creating) {
            return;
        }
        this._creating = true;
        const btn = document.getElementById('btnCreateGuestCallInvite');
        if (btn) {
            btn.disabled = true;
        }

        try {
            const res = await fetch(VCS.Chat.API_BASE + '/invite/create', {
                method : 'POST',
                headers: VCS.chat?.authHeaders({'Content-Type': 'application/json'}),
                body   : JSON.stringify({kind: 'call'}),
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok || !data.url) {
                console.warn('[guest-invite] create failed status=' + res.status + ' error=' + (data.error || '-'));
                const key = data.error === 'too_many_active_invites' ? 'inviteTooMany' : 'inviteCreateFailed';
                VCS.ui?.showToast?.(t(key), 'error', 5000);
                return;
            }

            // Erst das Modal schliessen, dann das Versand-Fenster -- sonst liegen
            // zwei Overlays uebereinander.
            const modal = bootstrap.Modal.getInstance($('#newChatModal')[0]);
            if (modal) {
                modal.hide();
            }
            VCS.chatContacts?._showInviteSheet?.(data.url, data.token, {
                title     : t('guestInviteSheetTitle'),
                shareText : t('guestInviteShareText'),
                shareTitle: t('guestInviteShareTitle'),
                // Der Server sagt, ob die Minuten reichen -- der Client rechnet
                // das nie selbst (Kontingent, Trial und Guthaben kennt nur er).
                note      : t(data.translationAvailable ? 'guestInviteTranslationOn' : 'guestInviteTranslationOff'),
            });
        } catch (err) {
            console.warn('[guest-invite] create error: ' + (err?.message || 'unknown'));
            VCS.ui?.showToast?.(t('inviteCreateFailed'), 'error', 5000);
        } finally {
            this._creating = false;
            if (btn) {
                btn.disabled = false;
            }
        }
    }

    // -- Klopfen des Gastes ---------------------------------------

    onKnock(msg) {
        const roomId = typeof msg?.roomId === 'string' ? msg.roomId : '';
        if (!roomId) {
            return;
        }
        const guestName = String(msg.guestName || '').trim() || t('guest');
        const s = VCS.state;

        // Schon in einem Gespraech: nicht dazwischenfunken. Der Gast bekommt
        // nach der Klingelzeit vom Server "keine Antwort".
        const phase = s.sessionState?.phase;
        if (s.groupCallActive || phase === 'call' || phase === 'waiting') {
            VCS.ui?.showToast?.(t('guestKnockBusy').replace('{name}', escapeHtml(guestName)), 'info', 6000);
            return;
        }

        this._closeOverlay();
        this._knockRoomId = roomId;

        const overlay = document.createElement('div');
        overlay.className = 'incoming-call-overlay';
        overlay.dataset.guestRoom = roomId;
        overlay.innerHTML = `
            <div class="incoming-call-avatar">${escapeHtml(guestName.charAt(0))}</div>
            <div class="incoming-call-name">${escapeHtml(guestName)}</div>
            <div class="incoming-call-type">${escapeHtml(t('guestKnockType'))}</div>
            <div class="incoming-call-actions">
                <button class="incoming-call-btn incoming-call-btn--decline" data-action="decline">
                    <span class="incoming-call-btn-circle">
                        <svg viewBox="0 0 24 24"><path d="M6.34 17.66l-1.41-1.41L10.59 12 4.93 6.34l1.41-1.41L12 10.59l5.66-5.66 1.41 1.41L13.41 12l5.66 5.66-1.41 1.41L12 13.41z"/></svg>
                    </span>
                    <span class="incoming-call-btn-label">${escapeHtml(t('decline'))}</span>
                </button>
                <button class="incoming-call-btn incoming-call-btn--accept" data-action="accept">
                    <span class="incoming-call-btn-circle">
                        <svg viewBox="0 0 24 24"><path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 01.98-.27c1.1.35 2.3.53 3.53.53a1 1 0 011 1V20a1 1 0 01-1 1C10.07 21 3 13.93 3 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.23.18 2.43.53 3.53a1 1 0 01-.27.97z"/></svg>
                    </span>
                    <span class="incoming-call-btn-label">${escapeHtml(t('accept'))}</span>
                </button>
            </div>
        `;

        overlay.querySelector('[data-action="accept"]').onclick = () => {
            this._closeOverlay();
            this.accept(roomId, guestName);
        };
        overlay.querySelector('[data-action="decline"]').onclick = () => {
            this._closeOverlay();
            VCS.signaling?.send({type: 'guest-knock-deny', roomId});
        };

        document.body.appendChild(overlay);
        VCS.audioMonitor?.startIncomingKnock?.();
        VCS.notify?.maybeNotifyJoinRequest?.(guestName);
        this._knockTimer = setTimeout(() => this._closeOverlay(), VCS.GuestInvite.KNOCK_TIMEOUT_MS);
    }

    // Gast hat aufgegeben, ein anderes Geraet hat angenommen/abgelehnt, oder
    // die Klingelzeit ist um.
    onKnockCancelled(msg) {
        if (msg?.roomId && this._knockRoomId && msg.roomId !== this._knockRoomId) {
            return;
        }
        this._closeOverlay();
    }

    // Annehmen: den Raum als Host betreten. guestAcceptPending setzt im
    // register-Paket guestAccept -- der Server laesst den Gast dann direkt
    // herein, ohne dass im Raum noch einmal gefragt wird.
    accept(roomId, guestName) {
        const s = VCS.state;
        VCS.callControls?.resetSummary?.();
        VCS.session?.updateRoomId(roomId);
        s.myName = ($('#regNameInput')[0]?.value || '').trim() || s.myName || s.chatMyName;
        s.directCallActive = true;
        s.directCallPeerName = guestName;
        s.directCallPeerPhone = '';
        s.guestCallActive = true;
        s.guestAcceptPending = true;

        const joinCall = () => {
            VCS.session?.update({name: s.myName, role: null, phase: 'waiting'});
            VCS.nav?.showScreen?.('waitingScreen');
            $('#hostWaiting')[0]?.classList.remove('hidden');
            $('#guestWaiting')[0]?.classList.add('hidden');
            VCS.session?.setRejoinHint(false);
            VCS.signaling?.requestRegister();
        };
        if (!s.localStream) {
            VCS.media?.initPreview?.().then(joinCall);
        } else {
            joinCall();
        }
    }

    // -- Private Methoden -----------------------------------------

    _closeOverlay() {
        clearTimeout(this._knockTimer);
        this._knockTimer = 0;
        this._knockRoomId = null;
        VCS.audioMonitor?.stopIncomingKnock?.();
        document.querySelectorAll('.incoming-call-overlay[data-guest-room]').forEach(el => el.remove());
    }

    _injectButton() {
        const anchor = document.getElementById('btnCreateInvite');
        if (!anchor || document.getElementById('btnCreateGuestCallInvite')) {
            return;
        }

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.id = 'btnCreateGuestCallInvite';
        btn.className = 'invite-link-btn mt-2';
        btn.innerHTML = '<svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">'
            + '<rect x="3" y="7" width="13" height="10" rx="2"></rect><path d="M16 10l5-3v10l-5-3z"></path></svg>'
            + '<span data-i18n="guestInviteCreate"></span>';
        btn.querySelector('span').textContent = t('guestInviteCreate');

        const hint = document.createElement('p');
        hint.className = 'invite-link-hint';
        hint.setAttribute('data-i18n', 'guestInviteHint');
        hint.textContent = t('guestInviteHint');

        // Unter den Hinweis des Kontakt-Einladungslinks.
        const contactHint = anchor.nextElementSibling;
        const insertAfter = contactHint?.classList.contains('invite-link-hint') ? contactHint : anchor;
        insertAfter.after(btn, hint);

        btn.addEventListener('click', () => void this.createLink());
    }
};

// Singleton, beim Bundle-Init angehaengt (analog VCS.liveCapNotice).
VCS.guestInvite = new VCS.GuestInvite();
